<!--<div class="ag-custom-component-popup">
  <dx-combobox
    [formControlInstance]="cbPlanType"
    controlId="testMultiCombo"
    [options]="cbOptions"
  >
  </dx-combobox>

</div>-->
<button class="mini ui icon button" (click)="onClick()"><i class="filter icon"></i></button>

